import type { POST_SLIDE_DATA, POST_SLIDE_PARAMS } from './types'

export const DEFAULT_POST_SLIDE_DATA = (): POST_SLIDE_DATA => ({
  type: 'post-slide',
  id: null,
  classes: null,
  data: {
    image: null,
    title: 'Lorem Ipsum',
    perex: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit',
  },
})

export const DEFAULT_POST_SLIDE_PARAMS = (): POST_SLIDE_PARAMS => ({
  color: null,
})
